$(document).ready(function () {
    $('#search-author').autocomplete({
        source: function (request, response) {
            $('#form-update-authors').trigger("reset")
            $('.item-country').val('')
            $('.item-country').trigger("chosen:updated")
            $('.item-avatar').attr('src', '')

            $.ajax({

                url: '/admin/author/search',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        showTitle = item.name
                        return {
                            label: showTitle,
                            item_country: item.country,
                            item_country_visible: item.country_visible.split(','),
                            item_biography: item.biography,
                            item_web: item.web,
                            item_facebook: item.facebook,
                            item_twitter: item.twitter,
                            item_img: '../images/autores/'+item.avatar,
                            value: item.name,
                            data: item,
                            id: item.id,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $(".item-id").val(ui.item.id)
            $(".item-name").val(ui.item.value)
            $('.item-country').val(ui.item.item_country);
            $('.item-country').trigger("chosen:updated");


            $('.item-country_visible').val(ui.item.item_country_visible);
            $('.item-country_visible').trigger("chosen:updated");

            $(".item-biography").val(ui.item.item_biography)
            $(".item-web").val(ui.item.item_web)
            $(".item-facebook").val(ui.item.item_facebook)
            $(".item-twitter").val(ui.item.item_twitter)
            $('.item-avatar').attr('src', ui.item.item_img);
        }
    });
});







